var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7106 2.1278L10.2041 2.125C8.51172 2.125 7.41801 3.42501 7.41801 5.43711V6.96422H5.90337C5.77249 6.96422 5.6665 7.08715 5.6665 7.23878V9.45139C5.6665 9.60302 5.77261 9.72581 5.90337 9.72581H7.41801V15.3089C7.41801 15.4605 7.524 15.5833 7.65488 15.5833H9.63105C9.76194 15.5833 9.86792 15.4604 9.86792 15.3089V9.72581H11.6389C11.7698 9.72581 11.8758 9.60302 11.8758 9.45139L11.8765 7.23878C11.8765 7.16598 11.8515 7.09625 11.8071 7.04473C11.7628 6.9932 11.7023 6.96422 11.6395 6.96422H9.86792V5.66967C9.86792 5.04746 9.9959 4.7316 10.6955 4.7316L11.7103 4.73118C11.8411 4.73118 11.9471 4.60825 11.9471 4.45675V2.40222C11.9471 2.25087 11.8412 2.12808 11.7106 2.1278Z",
    fill: "#1F798C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.47a8ac039c0a7c44bc64401ce19f732a.svg";
export { ForwardRef as ReactComponent };